import React from 'react'
import './styles.scss'
import { Helmet } from 'react-helmet'
import { format, differenceInCalendarDays } from 'date-fns'
import { get } from 'lodash'
import AD from 'react-google-publisher-tag';


class EventDetail extends React.Component {
  getEventSchedule(dates) {
    let eventSchedules = [];
    dates.forEach(dateObject => {
      var currentTime = dateObject.orgEventDate
        //parseInt(dateObject.eventDate, 10) * 1000 + 5 * 60 * 60 * 1000;
      if (
        differenceInCalendarDays(
          format(currentTime, "MM/DD/YYYY"),
          format(Date.now(), "MM/DD/YYYY")
        ) >= 0
      ) {
        eventSchedules.push({
          date: currentTime,
          showTime: dateObject.showTime,
          eventTime: dateObject.orgEventTime || '',
          doorTime: dateObject.orgDoorTime || ''
        });
      }
    });
    return eventSchedules;
  }
  // getCorrectTime(t){
  //   if(!t){
  //     return ''
  //   }
  //   return parseInt(t, 10) * 1000
  //   var offset = new Date(time).getTimezoneOffset()
  //   return time + (offset * 60 * 1000)
  // }

  get helmet() {
    const { gist = {}, seo = {} } = this.props.data.contentData[0];

    return (
      <Helmet>
        <title>{`${seo.title || gist.title} | ${window.settings.site}`}</title>
        <meta
          name="description"
          content={seo.description || gist.description}
        />
        {seo.keywords && (
          <meta name="keywords" content={seo.keywords.join(",")} />
        )}
        <meta property="og:type" content="event" />
        <meta property="og:title" content={seo.title || gist.title} />
        <meta
          property="og:description"
          content={seo.description || gist.description}
        />
        <meta
          property="og:image"
          content={gist.posterImageUrl || gist.videoImageUrl}
        />
      </Helmet>
    );
  }

  render() {
    const contentData = get(this.props, "data.contentData[0].gist");
    const innerHtml = { __html: get(contentData, 'details', '') };
    const eventSchedule = this.getEventSchedule(contentData.eventSchedule);
    const date = eventSchedule.length && eventSchedule[0].date;

    const { adTag, subscribeLinkUrl } = this.props.data.metadataMap || {}
    let remainingDates = [];
    if (eventSchedule.length > 1) {
      remainingDates = eventSchedule.slice(1);
    }

    return (
      <div className="event-page">
        {this.helmet}
        {contentData.imageGist["_16x9"] && (
          <div className="event-page-image-container">
            <img src={contentData.imageGist["_16x9"]} alt={contentData.title} />
          </div>
        )}
        <div className="event-details">
          <div className="event-description">
            <div className="event-title">{contentData.title}</div>
            <div className="event-desc">
              <div className="content" dangerouslySetInnerHTML={innerHtml} />
            </div>
          </div>
      
          <div className={`event-info ${eventSchedule.length > 0 ? '' : 'past'}`}>
            <div className="mob-title">{contentData.title}</div>

            { (eventSchedule.length > 0 && contentData.ticketUrl) && (
              <a
                href={contentData.ticketUrl}
                className="event-button site-background-color"
                target="_blank"
                rel="noopener noreferrer"
              >
                Tickets
              </a>
            )}

            { eventSchedule.length > 0 && 
              <div className="event-date-time-info">
                <div className="event-data">
                  <ion role="presentation" className="ion-calendar" />
                  <div className="event-meta">
                    <p>Date</p>
                    <p>
                      {format(date, "dddd")} | {format(date, "MMM D, YYYY")}
                    </p>
                  </div>
                </div>
                {eventSchedule[0].showTime && <div className="event-data">
                  <ion role="presentation" className="ion-android-time" />
                  <div className="event-meta">
                    <p>Time</p>
                    <p>{format(`${eventSchedule[0].date} ${eventSchedule[0].eventTime}`, 'h:mm A')}</p>
                  </div>
                </div>}
                {eventSchedule[0].doorTime && (
                  <div className="event-data">
                    <ion role="presentation" className="ion-ios-home" />
                    <div className="event-meta">
                      <p>Doors open</p>
                      <p>{format(`${eventSchedule[0].date} ${eventSchedule[0].doorTime}`,'h:mm A')}</p>
                    </div>
                  </div>
                )}
                {contentData.onSale && <div className="event-data">
                  <ion role="presentation" className="ion-ios-pricetags" />
                  <div className="event-meta">
                    <p>ON SALE NOW</p>
                  </div>
                </div>}
                {remainingDates.length > 0 && (
                  <div className="event-data">
                    <div className="event-meta">
                      <p>Additional Dates</p>
                      {remainingDates.map((event, i) => {
                        return (
                          <p>
                            {format(event.date, "dddd")} |{" "}
                            {format(event.date, "MMM D, YYYY")}
                          </p>
                        );
                      })}
                    </div>
                  </div>
                )}
              </div>
            }
          </div>

          {subscribeLinkUrl && (
            <a href={subscribeLinkUrl} className="coa-signup clearfix">
              <p>Become a coainsider</p>
              <p>sign up Today!</p>
              <button className="event-button sign-up clearfix">sign up</button>
            </a>
          )}
          {adTag && (
            <div className="event-ad clearfix">
              <AD path={adTag} dimensions={[[300, 250]]} />
            </div>
          )}

        </div>
      </div>
    );
  }
}

export default EventDetail
